import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { Image } from 'react-bootstrap';
import ChoiceTable from '../Components/ChoiceTable';

const Choice = (props) => {

  // Tilakoukku huolehtimaan focuksesta
  useEffect(() => {
    if(props.init !== props.data.id) {
      window.scrollTo(0, 0)
      props.setFocusId(props.data.id + "head")
      props.setInit(props.data.id)
    } else {
      document.getElementById(props.focusId).focus()
    }
  }, [props])

  return (
    <Container role="main" className="content" fluid>
      <Row className="justify-content-center">
        <Col md={12} xl={3} className="choiceSection">
          <ChoiceTable choice={props.choice} setChoice={ props.setChoice } data={props.data} popoverDirection={'right'} setFocusId={props.setFocusId} />
          <Container className="choiceButtonContainer">
            <Link to={props.data.links.next} title="Siirry eteenpäin" className="btn mainButton w-100">{props.data.buttons.confirmOne}</Link>
          </Container>
        </Col>
        <Col xl={3} className="d-none d-xl-block">
          <Image src={props.data.image} alt="Vinkkikuva" className="choiceImage" fluid />
        </Col>
      </Row>
    </Container>
  );
};

export default Choice;